import {coachingApi} from 'sources/api';

const CoachingStatsSource = {
  getCoachingStats(planId) {
    return coachingApi.getJson(`/plans/${planId}/stats`);
  },
};

export default CoachingStatsSource;
